import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { UpdateOpportunityRequest } from 'backend/types'
import { updateOpportunity } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseUpdateOpportunityOptions {
  onSuccess?: () => void
  onError?: (error: Error) => void
}

/**
 * オポチュニティを更新するミューテーションフック
 *
 * 詳細ページのキャッシュは無効化して再フェッチします。
 * 一覧のキャッシュは無効化せず、ユーザーが一覧に戻った際に自動的に再フェッチされます。
 *
 * @param opportunityId - オポチュニティID
 * @param options - フックオプション
 * @returns TanStack Query のミューテーション結果
 */
export function useUpdateOpportunity(opportunityId: number, options: UseUpdateOpportunityOptions = {}) {
  const { onSuccess, onError } = options
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: UpdateOpportunityRequest) => {
      return updateOpportunity(opportunityId, data)
    },
    onSuccess: () => {
      // 詳細ページのキャッシュを無効化して再取得
      queryClient.invalidateQueries({ queryKey: queryKeys.opportunity.all(opportunityId) })

      onSuccess?.()
    },
    onError: (error: Error) => {
      onError?.(error)
    },
  })
}
